import React from 'react'
import Select from 'react-select'
export default class ComboBox extends React.Component {
    render() {
        return (
            <Select
                value={this.props.value}
                options={this.props.options}
                onChange={value => this.props.onChange(value)}
                getOptionLabel={this.props.getOptionLabel}
                getOptionValue={this.props.getOptionValue}
                placeholder={this.props.placeholder}
            />
        )
    }
}


